class Panel{
    constructor(){
        this.tabs = document.querySelectorAll('.js-comparison-tab');
        this.panels = document.querySelectorAll(`[panel]`);
        this.event();
    }

    event(){
        this.tabs.forEach(el => {
            el.addEventListener("click", () => { this.tabSwitch(el) });
        });
    }

    tabSwitch(el){
        // タブのclassの値を変更
        document.querySelectorAll('.is-comparison-active')[0].classList.remove('is-comparison-active');
        el.classList.add('is-comparison-active');
        // コンテンツのclassの値を変更
        const arrayTabs = Array.prototype.slice.call(this.tabs);
        const panelIndex = arrayTabs.indexOf(el);
        this.panels.forEach( e => {
            if( e.getAttribute('panel') == panelIndex ){
                e.classList.add('is-comparison-show');
            } else {
                e.classList.remove('is-comparison-show');
            }
        })
    }
}

export default Panel